import React from 'react';
import MapComponent from '../MapComponent';
import FilterBar from './FilterBar';
import useInfiniteScroll from '../hooks/useInfiniteScroll';
import { SORT_OPTIONS } from '../config/filters';
import './SplitView.css';

const SplitView = ({
    properties,
    filters,
    onFilterChange,
    onCardClick,
    hoveredPropertyId,
    setHoveredPropertyId,
    PropertyCardComponent,
    isLoading,
    onLoadMore,
    hasMore,
    isFetchingNextPage,
    totalCount = 0,
    mapCenter,
    hasLocation = true,
    mapMarkers = [],
}) => {
    // We use the same hook but pass the parent's load function
    const sentinelRef = useInfiniteScroll(onLoadMore, hasMore, isFetchingNextPage);

    const handleSortChange = (e) => {
        onFilterChange({ sort_by: e.target.value });
    };

    return (
        <div className="split-view-container">
            <div className="split-view-header">
                <FilterBar filters={filters} onFilterChange={onFilterChange} />
            </div>
            <div className="split-view-content">
                <div className="split-view-map">
                    <MapComponent
                        properties={mapMarkers.length > 0 ? mapMarkers : properties}
                        hoveredPropertyId={hoveredPropertyId}
                        onMarkerClick={onCardClick}
                        center={mapCenter}
                    />
                </div>
                <div className="split-view-list">
                    <div className="list-header">
                        <div className="list-header-left">
                            <h2>Real Estate & Homes For Sale</h2>
                            <span className="result-count">
                                {isLoading ? 'Searching...' : totalCount > 0 ? `${totalCount.toLocaleString()} results` : `${properties.length} results`}
                            </span>
                        </div>
                        <div className="list-header-right">
                            <label htmlFor="sort-select" className="sort-label">Sort:</label>
                            <select
                                id="sort-select"
                                className="sort-select"
                                value={filters.sort_by || 'newest'}
                                onChange={handleSortChange}
                            >
                                {SORT_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {isLoading && properties.length === 0 ? (
                        <div className="loading-container">
                            <div className="spinner"></div>
                            <p>Finding the best deals for you...</p>
                        </div>
                    ) : (
                        <>
                            <div className="property-grid">
                                {properties.map(property => (
                                    <div
                                        key={property.property_id} // Ensure this is unique!
                                        onMouseEnter={() => setHoveredPropertyId(property.property_id)}
                                        onMouseLeave={() => setHoveredPropertyId(null)}
                                    >
                                        <PropertyCardComponent
                                            property={property}
                                            onCardClick={onCardClick}
                                        />
                                    </div>
                                ))}
                                {properties.length === 0 && !isLoading && (
                                    <div className="no-results">
                                        {hasLocation ? (
                                            <>
                                                <h3>No homes found</h3>
                                                <p>Try adjusting your search filters.</p>
                                            </>
                                        ) : (
                                            <>
                                                <h3>Search for a location to see properties</h3>
                                                <p>Enter a city or zip code above to get started.</p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Infinite Scroll Sentinel */}
                            <div ref={sentinelRef} className="infinite-scroll-sentinel">
                                {isFetchingNextPage && (
                                    <div className="loading-more-container">
                                        <div className="spinner-small"></div>
                                        <p>Loading more homes...</p>
                                    </div>
                                )}
                            </div>

                            {/* Show completion message */}
                            {!hasMore && properties.length > 0 && (
                                <div className="all-loaded-message">
                                    <p>✓ You've viewed all properties</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SplitView;
